var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3463_403917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 20V13M16 20V10M8 20L8 16M17.4067 5.0275L22.5751 6.96567M14.7988 5.40092L9.20023 9.59983M25.0607 6.43934C25.6464 7.02513 25.6464 7.97487 25.0607 8.56066C24.4749 9.14645 23.5251 9.14645 22.9393 8.56066C22.3536 7.97487 22.3536 7.02513 22.9393 6.43934C23.5251 5.85355 24.4749 5.85355 25.0607 6.43934ZM9.06066 9.43934C9.64645 10.0251 9.64645 10.9749 9.06066 11.5607C8.47487 12.1464 7.52513 12.1464 6.93934 11.5607C6.35355 10.9749 6.35355 10.0251 6.93934 9.43934C7.52513 8.85355 8.47487 8.85355 9.06066 9.43934ZM17.0607 3.43934C17.6464 4.02513 17.6464 4.97487 17.0607 5.56066C16.4749 6.14645 15.5251 6.14645 14.9393 5.56066C14.3536 4.97487 14.3536 4.02513 14.9393 3.43934C15.5251 2.85355 16.4749 2.85355 17.0607 3.43934Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3463_403917",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3463_403917"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3463_403917",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarLineChart);
export default __webpack_public_path__ + "static/media/bar-line-chart.a4ad2e21098ac083f4d5c497ca0eb9e7.svg";
export { ForwardRef as ReactComponent };